import * as Sentry from '@sentry/nuxt';

try {
  // Safe client-side initialization
  let dsn: string | undefined;
  let environment: string = 'development';
  
  try {
    // Try to use runtime config if available
    const config = useRuntimeConfig();
    dsn = config.public.sentryDNS;
    environment = config.public.environment || import.meta.env.MODE || 'development';
  } catch {
    // Fallback to import.meta.env if runtime config fails
    dsn = import.meta.env.VITE_SENTRY_DSN || import.meta.env.NUXT_PUBLIC_SENTRY_DNS;
    environment = import.meta.env.MODE || 'development';
  }

  if (dsn) {
    Sentry.init({
      dsn: dsn,
      environment: environment,
      tracesSampleRate: 0.25,
      replaysSessionSampleRate: 0.01,
      replaysOnErrorSampleRate: 1.0,

      // If you don't want to use Session Replay, just remove the line below:
      integrations: [Sentry.replayIntegration()],

      // Setting this option to true will print useful information to the console while you're setting up Sentry.
      debug: false,
    });
    
    console.log(`Sentry client initialized for environment: ${environment}`);
  } else {
    console.log('Sentry DSN not available on client side');
  }
} catch (error) {
  console.warn("Sentry client initialization failed:", error);
}
